module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.collection) ? _c('article', {
    staticClass: "collection",
    class: _vm.collection.slug
  }, [_c('header', [_c('h1', {
    staticClass: "h2 type-scales--large"
  }, [(_vm.number) ? [_vm._v("\n        Collection\n        "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.number) ? [_vm._v("\n        Nr. " + _vm._s(_vm.number) + "\n        "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.isBespoke) ? [_vm._v("\n        Dovedale Design"), _c('br'), _vm._v("Studio’s"), _c('br')] : _vm._e(), _vm._v("\n      " + _vm._s(_vm.title) + "\n      "), (_vm.isBespoke) ? [_c('div', {
    staticClass: "logo"
  }, [_c('LogoMarque')], 1)] : _vm._e()], 2)]), _vm._v(" "), (_vm.loadStory) ? _c('story', {
    attrs: {
      "sections": _vm.collection.getGroup('collection.sections').value,
      "mobile": _vm.mobile,
      "window": _vm.window
    }
  }) : _vm._e(), _vm._v(" "), _c('items', {
    attrs: {
      "collections": _vm.collections,
      "slug": _vm.slug,
      "itemViewName": 'Collection - Item Overlay'
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "outlined is-hidden-mobile"
  }, [(_vm.prevCollection) ? _c('router-link', {
    staticClass: "previous",
    attrs: {
      "to": {
        name: 'Collection',
        params: {
          slug: _vm.prevCollection.uid
        }
      }
    }
  }, [_c('span', [_vm._v("Previous")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "underline-links"
  }, [_c('span', {
    staticClass: "h7 nimbus-sans"
  }, [_vm._v("Share via "), _vm._l((_vm.shareBtns), function(button) {
    return [_c('a', {
      attrs: {
        "href": button.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(button.label))]), _vm._v(" ")]
  })], 2)]), _vm._v(" "), (_vm.nextCollection) ? _c('router-link', {
    staticClass: "next",
    attrs: {
      "to": {
        name: 'Collection',
        params: {
          slug: _vm.nextCollection.uid
        }
      }
    }
  }, [_c('span', [_vm._v("Next")])]) : _vm._e()], 1), _vm._v(" "), _c('nav', {
    staticClass: "is-hidden-tablet uppercase"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Collections'
      }
    }
  }, [_vm._v("Back to Collections")])], 1), _vm._v(" "), (_vm.site) ? _c('footer', {
    staticClass: "is-hidden-mobile"
  }, [_c('div', [_c('subscribe-form', {
    attrs: {
      "mailchimpNewsletterID": _vm.site.getText('site.mailchimp-newsletter-id')
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('appfooter', {
    attrs: {
      "site": _vm.site
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a052fea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection.vue
// module id = 394
// module chunks = 1